import { render, staticRenderFns } from "./ApplyNewFamily.vue?vue&type=template&id=0f5ac0f5&"
import script from "./ApplyNewFamily.vue?vue&type=script&lang=js&"
export * from "./ApplyNewFamily.vue?vue&type=script&lang=js&"
import style0 from "./ApplyNewFamily.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports